export interface DeeplinkParams {
  readonly vin?: string;
  readonly modelYear?: string;
  readonly model?: string;
}

// Only named, explicit URLSearchParams.get() calls are used here — never
// Object.fromEntries()/spread over parsed keys. That avoids the
// prototype-pollution class (CWE-250/CWE-400) the integrator's allowlist
// (7b07407) had to patch after the fact, by construction rather than denylist.
export function getDeeplinkParamsFromSearch(search: string): DeeplinkParams {
  const searchParams = new URLSearchParams(search);
  const vin = searchParams.get('utm_vin');
  const modelYear = searchParams.get('utm_model_year');
  const model = searchParams.get('utm_model');

  return {
    vin: vin || undefined,
    modelYear: modelYear || undefined,
    model: model || undefined,
  };
}

// The integrator's history-service is configured with `showroom-navigation`
// as the primary consumer (see create-root-location-transformer usage in
// packages/integrator/src/define-common-feature-services.ts). Per Feature
// Hub's consumer-history isolation, only the primary consumer's history sees
// raw root query params; every other consumer (including this feature app)
// only sees params previously encoded into its own reserved history slot.
// So `s2:history`'s `location.search` never contains `utm_*` params from a
// fresh page load — they must be read from the real request URL instead.
export function getSearchStringFromServerRequestUrl(url: string): string {
  const queryIndex = url.indexOf('?');
  return queryIndex === -1 ? '' : url.slice(queryIndex);
}
